import { render, staticRenderFns } from "./OptLangDropdown.vue?vue&type=template&id=3e62ce24&scoped=true"
import script from "./OptLangDropdown.vue?vue&type=script&lang=js"
export * from "./OptLangDropdown.vue?vue&type=script&lang=js"
import style0 from "./OptLangDropdown.vue?vue&type=style&index=0&id=3e62ce24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e62ce24",
  null
  
)

export default component.exports